// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FurnitureCard-module__main--O2Jqt {
    border-radius: 12px;
    background-color: var(--color-general-background);
    overflow: hidden;
}

.FurnitureCard-module__imageContainer--fLAp_ {
    overflow: hidden;
    border-radius: 12px;
    height: 200px;
    position: relative;
}

.FurnitureCard-module__infoButton--DXuHN {
    position: absolute;
    right: 12px;
    top: 12px;
}

.FurnitureCard-module__imageContainer--fLAp_ img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.FurnitureCard-module__contentContainer--vvvyt {
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/SelectFurniture/FurnitureCard.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iDAAiD;IACjD,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB","sourcesContent":[".main {\n    border-radius: 12px;\n    background-color: var(--color-general-background);\n    overflow: hidden;\n}\n\n.imageContainer {\n    overflow: hidden;\n    border-radius: 12px;\n    height: 200px;\n    position: relative;\n}\n\n.infoButton {\n    position: absolute;\n    right: 12px;\n    top: 12px;\n}\n\n.imageContainer img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.contentContainer {\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `FurnitureCard-module__main--O2Jqt`,
	"imageContainer": `FurnitureCard-module__imageContainer--fLAp_`,
	"infoButton": `FurnitureCard-module__infoButton--DXuHN`,
	"contentContainer": `FurnitureCard-module__contentContainer--vvvyt`
};
export default ___CSS_LOADER_EXPORT___;
